import {
  FillingBatchComponentBatch,
  CreateFillingBatchComponentBatchRequest,
  UpdateFillingBatchComponentBatchRequest,
  AvailableComponentBatch
} from '../types/fillingBatchComponentBatch';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003/api';

export const fillingBatchComponentBatchApiService = {
  /**
   * Fetch all filling batch component batches from the backend
   */
  fetchAllFillingBatchComponentBatches: async (): Promise<FillingBatchComponentBatch[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/filling-batch-component-batches`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch filling batch component batches');
      }

      return data.fillingBatchComponentBatches;
    } catch (error) {
      console.error('Error fetching filling batch component batches from API:', error);
      throw error;
    }
  },

  /**
   * Fetch filling batch component batches by filling batch ID
   */
  fetchFillingBatchComponentBatchesByFillingBatchId: async (fillingBatchId: string): Promise<FillingBatchComponentBatch[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/filling-batch-component-batches/by-filling-batch/${fillingBatchId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch filling batch component batches');
      }

      return data.fillingBatchComponentBatches;
    } catch (error) {
      console.error('Error fetching filling batch component batches by filling batch ID from API:', error);
      throw error;
    }
  },

  /**
   * Fetch available component batches for a filling (for dropdown filtering)
   */
  fetchAvailableComponentBatchesForFilling: async (fillingId: string): Promise<AvailableComponentBatch[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/filling-batch-component-batches/available-for-filling/${fillingId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch available component batches');
      }

      return data.availableComponentBatches;
    } catch (error) {
      console.error('Error fetching available component batches for filling from API:', error);
      throw error;
    }
  },

  /**
   * Create a new filling batch component batch
   */
  createFillingBatchComponentBatch: async (componentBatch: CreateFillingBatchComponentBatchRequest): Promise<FillingBatchComponentBatch> => {
    try {
      const response = await fetch(`${API_BASE_URL}/filling-batch-component-batches`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(componentBatch)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to create filling batch component batch');
      }

      return data.fillingBatchComponentBatch;
    } catch (error) {
      console.error('Error creating filling batch component batch:', error);
      throw error;
    }
  },

  /**
   * Update an existing filling batch component batch
   */
  updateFillingBatchComponentBatch: async (id: string, componentBatch: UpdateFillingBatchComponentBatchRequest): Promise<FillingBatchComponentBatch> => {
    try {
      const response = await fetch(`${API_BASE_URL}/filling-batch-component-batches/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(componentBatch)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to update filling batch component batch');
      }

      return data.fillingBatchComponentBatch;
    } catch (error) {
      console.error('Error updating filling batch component batch:', error);
      throw error;
    }
  },

  /**
   * Delete a filling batch component batch by ID
   */
  deleteFillingBatchComponentBatch: async (id: string): Promise<void> => {
    try {
      const response = await fetch(`${API_BASE_URL}/filling-batch-component-batches/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to delete filling batch component batch');
      }
    } catch (error) {
      console.error('Error deleting filling batch component batch:', error);
      throw error;
    }
  }
};
